import Col from "react-bootstrap/Col";
import {Nav, Row, Tab} from "react-bootstrap";
import Vendormaster from "../Body/Vendor/Vendormaster";
import LaborerMaster from "../Body/Laborer/LaborerMaster";
import "./Sidebar.css";
import Department from "../Body/Department/Department";
import VendorCLAssignment from "../Body/VendorCLAssignment/VendorCLAssignment";
import Security from "../Body/Security/Security";
import VendorAssignment from "../Body/VendorAssignment/VendorAssignment";
import VendorAssignmentList from "../Body/VendorAssignment/VendorAssignmentList";
import {useEffect, useRef, useState} from "react";
import VendorCLAssignmentList from "../Body/VendorCLAssignment/VendorCLAssignmentList";
import {useNavigate} from "react-router-dom";
import LabourMasterDataTable from "../Body/Laborer/LabourMasterDataTable";
import EditLaborerMaster from "../Body/Laborer/EditLaborerMaster";
import VendorMasterDataTable from "../Body/Vendor/VendorMasterDataTable";
import EditVendorMaster from "../Body/Vendor/EditVendorMaster";
import ReportSectionSidebar from "../Body/ReportsSection/ReportSectionSidebar";
import CLRErodeDataReportPage from "../Body/ReportsSection/CLRErodeDataReportPage";
import DeptTransactionDetailsReportPage from "../Body/ReportsSection/DeptTransactionDetailsReportPage";
import SecurityReportPage from "../Body/ReportsSection/SecurityReportPage";
import VendorAssignmentReportPage from "../Body/ReportsSection/VendorAssignmentReportPage";
import VendorCLAssignmentReportPage from "../Body/ReportsSection/VendorCLAssignmentReportPage";
import UsersManagementDataTable from "../Body/AccountsManagement/UsersManagementDataTable";
import "../Body/ReportsSection/ReportSection.css";
import "../../styles/layout.css";
import Payouts from "../Body/Payouts/Payouts";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
    faClipboard,
    faClipboardUser,
    faPeopleArrows,
    faPeopleCarryBox,
    faPeopleGroup,
    faPersonCircleCheck,
    faPersonCirclePlus,
    faSitemap,
    faTable,
    faUser,
    faUserCheck,
    faUsers,
    faWallet,
    faClock
} from "@fortawesome/free-solid-svg-icons";
import LabourPay from "../Body/Payouts/LabourPay";
import UsersManagement from "../Body/AccountsManagement/UsersManagement";
import SingleLabour from "../Body/Payouts/SingleLabour";
import DeviceAttendance from "../Body/ReportsSection/DeviceAttendance";
import LiveLog from "../Body/ReportsSection/LiveLog";
// import ApprenticeDashboard from "../Body/Apprentice/ApprenticeDashboard";
// import ApprenticeManagement from "../Body/Apprentice/ApprenticeManagement";
// import LeaveApproval from "../Body/Apprentice/LeaveApproval";

function Sidebar() {
    // const [loadModule,setLoadModule] = useState(1);
    // const [rowData,setRowData] = useState({});
    const navigate = useNavigate();
    const [loadModule, setLoadModule] = useState("");
    const [roleKey, setRoleKey] = useState("");
    const [role, setRole] = useState("");
    const [vendorId, setVendorId] = useState("");
    const [labourId, setLabourId] = useState("");
    const [range, setRange] = useState("");
    const [payoutSource, setPayoutSource] = useState("facial");
    const dataInRow = useRef({});
    const [reportSectionView, setReportSectionView] = useState(false);

    const HandleEvent = (num) => {
        setLoadModule(num);
    };

    const reportSection = (e) => {
        // setLoadModule('16');
        setReportSectionView(!reportSectionView);
    };
    const HandleEventGetId = (num, row) => {
        dataInRow.current = row;
        setLoadModule(num);
        // setRowData(row);
    };
    const HandleEventGetVendorId = (num, vendorId, rangeValue, source) => {
        console.log(vendorId);
        setVendorId(vendorId);
        setLoadModule(num);
        if (rangeValue) {
            setRange(rangeValue);
        }
        if (source) {
            setPayoutSource(source);
        }
    };
    const HandleEventGetLabourId = (num, labourId, rangeValue, source) => {
        console.log(labourId);
        setLabourId(labourId);
        setLoadModule(num);
        setRange(rangeValue);
        if (source) {
            setPayoutSource(source);
        }
    }

    useEffect(() => {
        const userrole = localStorage.getItem("role");
        if (userrole == "" || userrole == null) {
            navigate("/", {replace: true});
            return;
        } else {
            setRole(userrole);
            switch (role) {
                case "Admin":
                    setRoleKey(1);
                    setLoadModule(1);
                    break;
                case "Vendor":
                    setRoleKey(2);
                    setLoadModule(2);
                    break;
                case "Security":
                    setRoleKey(5);
                    setLoadModule(5);
                    break;
                case "Department":
                    setRoleKey(4);
                    setLoadModule(4);
                    break;
                case "Supervisor":
                    setRoleKey(7);
                    setLoadModule(7);
                    break;
                case "SuperAdmin":
                    setRoleKey(1);
                    setLoadModule(1);
                    break;
                // case "Apprentice":
                //     setRoleKey(3);
                //     setLoadModule(30);
                //     break;
            }
        }
    }, [roleKey, role]);

    return (<Row className="g-0 clms-app-row">
        {roleKey != "" && (<Tab.Container
            id="left-tabs-example"
            defaultActiveKey={roleKey}
        >
            <aside className="tabNavBG">
                <Nav variant="pills" className="flex-column ">
                    {/*<img src={cklogo} className="ckLogoImg" alt="" />*/}

                    {/*{(role == "Apprentice") && (<Nav.Item*/}
                    {/*    className="noBorderRadius"*/}
                    {/*    onClick={(e) => setLoadModule("30")}*/}
                    {/*>*/}
                    {/*    <Nav.Link className="navMenuRadius" eventKey="3">*/}
                    {/*        <div className={"fontAwesomeDiv"}>*/}
                    {/*            <FontAwesomeIcon icon={faUser} className={"sidebarIcons"}/>*/}
                    {/*        </div>*/}
                    {/*        Apprentice Dashboard*/}
                    {/*    </Nav.Link>*/}
                    {/*</Nav.Item>)}*/}
                    {(role == "Admin" || role == "SuperAdmin") && (<Nav.Item
                        className="noBorderRadius"
                        onClick={(e) => setLoadModule("1")}
                    >
                        <Nav.Link className="navMenuRadius" eventKey="1">
                            <div className={"fontAwesomeDiv"}>
                                <FontAwesomeIcon icon={faUser} className={"sidebarIcons"}/>
                            </div>
                            <div>
                                Vendor Master
                            </div>
                        </Nav.Link>
                    </Nav.Item>)}
                    {(role == "Vendor" || role == "Admin" || role == "SuperAdmin" || role == "Security") && (<Nav.Item
                        className="noBorderRadius"
                        onClick={(e) => setLoadModule("2")}
                    >
                        <Nav.Link className="navMenuRadius" eventKey="2">
                            <div className={"fontAwesomeDiv"}>
                                <FontAwesomeIcon icon={faPeopleGroup} className={"sidebarIcons"}/>
                            </div>
                            Laborer Master
                        </Nav.Link>
                    </Nav.Item>)}

                    {/*{(role == "Admin" || role == "SuperAdmin") && (<Nav.Item*/}
                    {/*    className="noBorderRadius"*/}
                    {/*    onClick={(e) => setLoadModule("31")}*/}
                    {/*>*/}
                    {/*    <Nav.Link className="navMenuRadius" eventKey="31">*/}
                    {/*        <div className={"fontAwesomeDiv"}>*/}
                    {/*            <FontAwesomeIcon icon={faUsers} className={"sidebarIcons"}/>*/}
                    {/*        </div>*/}
                    {/*        Apprentice Management*/}
                    {/*    </Nav.Link>*/}
                    {/*</Nav.Item>)}*/}

                    {/*{(role == "Supervisor" || role == "Admin" || role == "SuperAdmin") && (<Nav.Item*/}
                    {/*    className="noBorderRadius"*/}
                    {/*    onClick={(e) => setLoadModule("32")}*/}
                    {/*>*/}
                    {/*    <Nav.Link className="navMenuRadius" eventKey="32">*/}
                    {/*        <div className={"fontAwesomeDiv"}>*/}
                    {/*            <FontAwesomeIcon icon={faClipboard} className={"sidebarIcons"}/>*/}
                    {/*        </div>*/}
                    {/*        Leave Approvals*/}
                    {/*    </Nav.Link>*/}
                    {/*</Nav.Item>)}*/}
                    {(role == "Supervisor" || role == "Admin" || role == "SuperAdmin") && (<Nav.Item
                        className="noBorderRadius"
                        onClick={(e) => setLoadModule("7")}
                    >
                        <Nav.Link className="navMenuRadius" eventKey="7">
                            <div className={"fontAwesomeDiv"}>
                                <FontAwesomeIcon icon={faPeopleArrows} className={"sidebarIcons"}/>
                            </div>
                            Vendor Assignment
                        </Nav.Link>
                    </Nav.Item>)}
                    {(role == "Vendor" || role == "Admin" || role == "SuperAdmin" || role == "Security") && (<Nav.Item
                        className="noBorderRadius"
                        onClick={(e) => setLoadModule("6")}
                    >
                        <Nav.Link className="navMenuRadius" eventKey="6">
                            <div className={"fontAwesomeDiv"}>
                                <FontAwesomeIcon icon={faPersonCirclePlus} className={"sidebarIcons"}/>
                            </div>
                            <div>
                                Vendor CL Assignment
                            </div>
                        </Nav.Link>
                    </Nav.Item>)}
                    {(role == "Department" || role == "Admin" || role == "SuperAdmin") && (<Nav.Item
                        className="noBorderRadius"
                        onClick={(e) => setLoadModule("4")}
                    >
                        <Nav.Link className="navMenuRadius" eventKey="4">
                            <div className={"fontAwesomeDiv"}>
                                <FontAwesomeIcon icon={faUserCheck} className={"sidebarIcons"}/>
                            </div>
                            Department
                        </Nav.Link>
                    </Nav.Item>)}
                    {(role == "Security" || role == "Admin" || role == "SuperAdmin") && (<Nav.Item
                        className="noBorderRadius"
                        onClick={(e) => setLoadModule("5")}
                    >
                        <Nav.Link className="navMenuRadius" eventKey="5">
                            <div className={"fontAwesomeDiv"}>
                                <FontAwesomeIcon icon={faPersonCircleCheck} className={"sidebarIcons"}/>
                            </div>
                            Security
                        </Nav.Link>
                    </Nav.Item>)}
                    {/* {role == "SuperAdmin" && (<Nav.Item
                        className="noBorderRadius"
                        onClick={(e) => setLoadModule("21")}
                    >
                        <Nav.Link className="navMenuRadius" eventKey="16">
                            <div className={"fontAwesomeDiv"}>
                                <FontAwesomeIcon icon={faUsers} className={"sidebarIcons"}/>
                            </div>
                            Users Management
                        </Nav.Link>
                    </Nav.Item>)} */}
                    {(role == 'Admin' || role == "SuperAdmin") &&
                        <Nav.Item className='noBorderRadius showHideReport' onClick={e => setLoadModule('101')}>
                            <Nav.Link className='navMenuRadius' eventKey="100">
                                <div className={"fontAwesomeDiv"}>
                                    <FontAwesomeIcon icon={faWallet} className={"sidebarIcons"}/>
                                </div>
                                Payouts
                            </Nav.Link>
                        </Nav.Item>}

                    {(role == "Admin" || role == "SuperAdmin") && (<Nav.Item
                        className={`noBorderRadius showHideReport ${reportSectionView === true ? "reporttoggle" : ""}`}
                        onClick={(e) => reportSection(e)}
                    >
                        <Nav.Link
                            className={`navMenuRadius ${reportSectionView === true ? "reporttoggle" : ""}`}
                        >
                            <div className={"fontAwesomeDiv"}>
                                <FontAwesomeIcon icon={faChevronRight} className={"chevronarrow"}/>
                            </div>
                            Report Section
                        </Nav.Link>
                    </Nav.Item>)}
                    {(role == "Admin" || role == "SuperAdmin") && reportSectionView ? (<div className={"subreport"}>
                        <Nav.Item
                            className="noBorderRadius"
                            onClick={(e) => setLoadModule("16")}
                        >
                            <Nav.Link className="navMenuRadius" eventKey="11">
                                <div className={"fontAwesomeDiv"}>
                                    <FontAwesomeIcon icon={faTable} className={"sidebarIcons"}/>
                                </div>
                                CLR Data
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="noBorderRadius"
                            onClick={(e) => setLoadModule("17")}
                        >
                            <Nav.Link className="navMenuRadius" eventKey="12">
                                <div className={"fontAwesomeDiv"}>
                                    <FontAwesomeIcon icon={faClipboard} className={"sidebarIcons"}/>
                                </div>
                                Security Attendance Data
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item
                            className="noBorderRadius"
                            onClick={(e) => setLoadModule("23")}
                        >
                            <Nav.Link className="navMenuRadius" eventKey="17">
                                <div className={"fontAwesomeDiv"}>
                                    <FontAwesomeIcon icon={faClipboard} className={"sidebarIcons"}/>
                                </div>
                                Gate Attendance Data
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item
                            className="noBorderRadius"
                            onClick={(e) => setLoadModule("18")}
                        >
                            <Nav.Link className="navMenuRadius" eventKey="13">
                                <div className={"fontAwesomeDiv"}>
                                    <FontAwesomeIcon icon={faClipboardUser} className={"sidebarIcons"}/>
                                </div>
                                Dept Attendance Data
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item
                            className="noBorderRadius"
                            onClick={(e) => setLoadModule("24")}
                        >
                            <Nav.Link className="navMenuRadius" eventKey="24">
                                <div className={"fontAwesomeDiv"}>
                                    <FontAwesomeIcon icon={faClock} className={"sidebarIcons"}/>
                                </div>
                                Live Log
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item
                            className="noBorderRadius"
                            onClick={(e) => setLoadModule("19")}
                        >
                            <Nav.Link className="navMenuRadius" eventKey="14">
                                <div className={"fontAwesomeDiv"}>
                                    <FontAwesomeIcon icon={faPeopleCarryBox} className={"sidebarIcons"}/>
                                </div>
                                Vendor Assigned Data
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item
                            className="noBorderRadius"
                            onClick={(e) => setLoadModule("20")}
                        >
                            <Nav.Link className="navMenuRadius" eventKey="15">
                                <div className={"fontAwesomeDiv"}>
                                    <FontAwesomeIcon icon={faSitemap} className={"sidebarIcons"}/>
                                </div>
                                Vendor CL Assigned Data
                            </Nav.Link>
                        </Nav.Item>

                    </div>) : ("")}

                </Nav>
            </aside>
            <Col xs={12} className="tabContentBG">
                <Tab.Content>
                    <Tab.Pane eventKey="1">
                        {loadModule == "1" && (<VendorMasterDataTable
                            HandleEvent={HandleEvent}
                            HandleEventGetId={HandleEventGetId}
                        />)}
                        {loadModule == "11" && (<Vendormaster HandleEvent={HandleEvent}/>)}
                        {loadModule == "12" && (<EditVendorMaster
                            HandleEvent={HandleEvent}
                            data={dataInRow.current}
                        />)}
                    </Tab.Pane>
                    <Tab.Pane eventKey="2">
                        {loadModule == "2" && (<LabourMasterDataTable
                            HandleEvent={HandleEvent}
                            HandleEventGetId={HandleEventGetId}
                        />)}
                        {loadModule == "9" && (<LaborerMaster HandleEvent={HandleEvent}/>)}
                        {loadModule == "10" && (<EditLaborerMaster
                            HandleEvent={HandleEvent}
                            data={dataInRow.current}
                        />)}
                    </Tab.Pane>
                    {/*<Tab.Pane eventKey="3">*/}
                    {/*    {loadModule=='3' && <DailyShift />}*/}
                    {/*</Tab.Pane>*/}
                    <Tab.Pane eventKey="4">
                        {loadModule == "4" && <Department/>}
                    </Tab.Pane>
                    <Tab.Pane eventKey="5">
                        {loadModule == "5" && <Security/>}
                    </Tab.Pane>
                    <Tab.Pane eventKey="6">
                        {loadModule == "6" && (<VendorCLAssignmentList
                            HandleEvent={HandleEvent}
                            HandleEventGetId={HandleEventGetId}
                        />)}
                        {loadModule == "6.1" && (<VendorCLAssignment data={dataInRow.current}/>)}
                    </Tab.Pane>
                    <Tab.Pane eventKey="7">
                        {loadModule == "7" && (<VendorAssignmentList
                            HandleEvent={HandleEvent}
                            HandleEventGetId={HandleEventGetId}
                        />)}
                        {loadModule == "7.1" && (<VendorAssignment data={dataInRow.current}/>)}
                    </Tab.Pane>
                    <Tab.Pane eventKey="16">
                        {loadModule == "21" && <UsersManagementDataTable/>}
                        {loadModule == "22" && (
                            <UsersManagement HandleEvent={HandleEvent}/>
                            )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="9">
                        {loadModule == "13" && <ReportSectionSidebar/>}
                    </Tab.Pane>
                    <Tab.Pane eventKey="100">
                        {loadModule == "101" && <Payouts
                            HandleEvent={HandleEvent}
                            HandleEventGetVendorId={HandleEventGetVendorId}
                            payoutSource={payoutSource}
                        />}
                        {loadModule == "102" && <LabourPay
                            vendorId={vendorId}
                            rangeValue={range}
                            payoutSource={payoutSource}
                            HandleEventGetLabourId={HandleEventGetLabourId}
                        />}
                        {loadModule == "103" && <SingleLabour
                            labourId={labourId}
                            rangeValue={range}
                            payoutSource={payoutSource}
                        />}
                    </Tab.Pane>
                    <Tab.Pane eventKey="11">
                        {loadModule == "16" && <CLRErodeDataReportPage/>}
                    </Tab.Pane>
                    <Tab.Pane eventKey="12">
                        {loadModule == "17" && <SecurityReportPage/>}
                    </Tab.Pane>
                    <Tab.Pane eventKey="13">
                        {loadModule == "18" && <DeptTransactionDetailsReportPage/>}
                    </Tab.Pane>
                    <Tab.Pane eventKey="17">
                        {loadModule == "23" && <DeviceAttendance />}
                    </Tab.Pane>
                    <Tab.Pane eventKey="24">
                        {loadModule == "24" && <LiveLog />}
                    </Tab.Pane>
                    <Tab.Pane eventKey="14">
                        {loadModule == "19" && <VendorAssignmentReportPage/>}
                    </Tab.Pane>
                    <Tab.Pane eventKey="15">
                        {loadModule == "20" && <VendorCLAssignmentReportPage/>}
                    {/*</Tab.Pane>*/}
                    {/*<Tab.Pane eventKey="3">*/}
                    {/*    {loadModule == "30" && <ApprenticeDashboard />}*/}
                    {/*</Tab.Pane>*/}
                    {/*<Tab.Pane eventKey="31">*/}
                    {/*    {loadModule == "31" && <ApprenticeManagement />}*/}
                    {/*</Tab.Pane>*/}
                    {/*<Tab.Pane eventKey="32">*/}
                    {/*    {loadModule == "32" && <LeaveApproval />}*/}
                    </Tab.Pane>
                    {/*<Tab.Pane eventKey="8">*/}
                    {/*    <LabourMasterDataTable />*/}
                    {/*</Tab.Pane>*/}
                    {/* <Tab.Pane eventKey="10">
                            <MasterVendor />
                        </Tab.Pane> */}
                </Tab.Content>
            </Col>
        </Tab.Container>)}
    </Row>);
}

export default Sidebar;
